import { Box, InputAdornment, Popover, TextField } from '@mui/material'
import { trimHexColor } from '@utils/color'
import React, { useState } from 'react'
import { HexColorPicker } from 'react-colorful'

type Props = {
  label: string
  value: string
  onChange: (value: string) => void
  id?: string
}

const HexColorInput: React.FC<Props> = ({ label, value, onChange, id }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const handleSwatchClick = (e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget)
  }

  const handleClose = () => setAnchorEl(null)

  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(trimHexColor(e.target.value))
  }

  return (
    <>
      <TextField
        label={label}
        id={id}
        value={value}
        onChange={handleTextChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Box
                onClick={handleSwatchClick}
                sx={{
                  backgroundColor: value,
                  width: '20px',
                  height: '20px',
                  borderRadius: '3px',
                  cursor: 'pointer',
                  border: '1px solid rgba(0,0,0,0.2)',
                  flexShrink: 0
                }}
              />
            </InputAdornment>
          )
        }}
      />
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        <Box p={2}>
          <HexColorPicker color={value} onChange={onChange} />
        </Box>
      </Popover>
    </>
  )
}

export default HexColorInput
